import Vue from 'vue'
import Router from 'vue-router'
import Layout from '@/layout/index.vue'

Vue.use(Router)

const routes = [
  {
    path: '/login',
    component: () => import('@/views/login/index.vue'),
    hidden: true
  },
  {
    path: '/',
    component: Layout,
    redirect: '/dashboard',
    children: [
      {
        path: 'dashboard',
        name: 'Dashboard',
        component: () => import('@/views/dashboard/index.vue'),
        meta: { title: '首页', icon: 'el-icon-s-home' }
      }
    ]
  },
  {
    path: '/institution',
    component: Layout,
    meta: { title: '机构管理', icon: 'el-icon-office-building' },
    children: [
      {
        path: '',
        name: 'InstitutionList',
        component: () => import('@/views/institution/list.vue'),
        meta: { title: '机构列表' }
      },
      {
        path: 'edit/:id?',
        name: 'InstitutionEdit',
        component: () => import('@/views/institution/edit.vue'),
        meta: { title: '机构编辑' },
        hidden: true
      }
    ]
  },
  {
    path: '/content',
    component: Layout,
    children: [
      {
        path: 'review',
        name: 'ContentReview',
        component: () => import('@/views/content/review.vue'),
        meta: { title: '内容审核', icon: 'el-icon-document-checked' }
      }
    ]
  },
  {
    path: '/order',
    component: Layout,
    meta: { title: '订单管理', icon: 'el-icon-s-order' },
    children: [
      {
        path: 'list',
        name: 'OrderList',
        component: () => import('@/views/order/list.vue'),
        meta: { title: '订单列表' }
      },
      {
        path: 'refund',
        name: 'OrderRefund',
        component: () => import('@/views/order/refund.vue'),
        meta: { title: '退款审核' }
      }
    ]
  },
  {
    path: '/appointment',
    component: Layout,
    children: [
      {
        path: 'list',
        name: 'AppointmentList',
        component: () => import('@/views/appointment/list.vue'),
        meta: { title: '预约管理', icon: 'el-icon-date' }
      }
    ]
  },
  {
    path: '/user',
    component: Layout,
    children: [
      {
        path: 'list',
        name: 'UserList',
        component: () => import('@/views/user/list.vue'),
        meta: { title: '用户管理', icon: 'el-icon-user' }
      }
    ]
  },
  {
    path: '/system',
    component: Layout,
    meta: { title: '系统管理', icon: 'el-icon-setting' },
    children: [
      {
        path: 'admin',
        name: 'AdminManagement',
        component: () => import('@/views/system/admin.vue'),
        meta: { title: '管理员管理' }
      }
    ]
  }
]

const createRouter = () => new Router({
  scrollBehavior: () => ({ y: 0 }),
  routes
})

const router = createRouter()

export function resetRouter() {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher
}

export default router
